import axiosInstance from "../axiosInstance";



export const GETAPPLISTPAGEDATA = () => {
   return `${process.env.REACT_APP_BASE_URL}/appstore/homepage`;
};


export const NAVBARAPPLISTING = () => {

// Concatenate the base URL with the endpoint
   return `${process.env.REACT_APP_BASE_URL}/appstore/app-listing` 
  
};

console.log(process.env.REACT_APP_BASE_URL);
console.log(NAVBARAPPLISTING());
console.log(GETAPPLISTPAGEDATA());
export const VERIFYTOKEN = () => {
    const baseurls=`${process.env.REACT_APP_BASE_URL}/seller/v1/verify-token`;
     return `${baseurls}`;
  };

  export const ALLAPPS = (pageNumber) => {
    const baseurls=`${process.env.REACT_APP_BASE_URL}/appstore/?page=${pageNumber}&limit=6`;
     return `${baseurls}`;
  };

export const CREATEAPP = () => {
   return `${process.env.REACT_APP_BASE_URL}/appstore/app/v1/create-app`;

};

export const GETAPPDETAILS = (slug) => {
  return `${process.env.REACT_APP_BASE_URL}/appstore/app-info?slug=${slug}`;
};
export const POSTINSTALLAPP = () => {
   return `${process.env.REACT_APP_BASE_URL}/seller/v1/install-app`;
 };

 export const GETAPPREVIEWS = (app_id,page) => {
   return `${process.env.REACT_APP_BASE_URL}/appstore/app-rating?app_id=${app_id}&page=${page}&limit=4`;
 };
 export const POSTAPPRATING = () => {
   return `${process.env.REACT_APP_BASE_URL}/seller/v1/app-rating`;
 };

 export const LOGOUT = async (data,token) => {
   const urls=process.env.REACT_APP_LOG_OUT;
   const logOutUrls=`${urls}/v1/auth/logout`;
   const response = await axiosInstance.post(logOutUrls, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; 
   
 };
 export const POSTINSTALLAPP2 = () => {
  return `${process.env.REACT_APP_BASE_URL}/seller/v1/install`;
};
export const POSTPERMISSIONAPPROVAL = () => {
  return `${process.env.REACT_APP_BASE_URL}/seller/v1/permission-approval`;
};
export const POSTPERMISSION = (app_id) => {
  return `${process.env.REACT_APP_BASE_URL}/seller/v1/${app_id}/permissions`;
};

export const SUBSCRIPTION_VERIFY = (token) => {
  return `${process.env.REACT_APP_BASE_URL}/seller/v1/subscribe/verify`;
};
export const SUBSCRIPTION_CREATE= () => {
  return `${process.env.REACT_APP_BASE_URL}/seller/v1/subscribe/create`;
};


export const CONTACTUSAPI = () => {
  return `${process.env.REACT_APP_BASE_URL}/appstore/contact-us`;
};
export const AUDIENCEAPI = () => {
  return `${process.env.REACT_APP_BASE_URL}/seller/v1/audience`;
};
export const AUDIENCEPERFORMANCEAPI = (acc_id) => {
  return `${process.env.REACT_APP_BASE_URL}/seller/v1/get-campaigns?ad_account_id=${acc_id}`;
};
export const CHECKAUDIENCEDATA = () => {
  return `${process.env.REACT_APP_BASE_URL}/seller/v1/audience`;
};
export const AUDIENCECONTACTUS = async (data) => {

  const url = `${process.env.REACT_APP_BASE_URL}/seller/v1/audience/mail`;
  try {
    const response = await axiosInstance.post(url, data);
    return response;  // Return only the data part
  } catch (error) {
    console.error('Error in AUDIENCEData API:', error);
    throw error;
  }
};

export const AUDIENCEPRODUCTDATA = async (data: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}/seller/v1/audience/details`;
  try {
    const response = await axiosInstance.post(url, data);
    return response;  // Return only the data part
  } catch (error) {
    console.error('Error in AUDIENCEData API:', error);
    throw error;
  }
};

// Define the AUDIENCEPAYMENTS function, which makes the API call
export const AUDIENCEPAYMENTS = async (data: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}/seller/v1/generate/payment-link`;
  try {
    const response = await axiosInstance.post(url, data);
    return response.data;  // Return only the data part
  } catch (error) {
    console.error('Error in AUDIENCEPAYMENTS API:', error);
    throw error;
  }
};
export const VERFYPAYMENT = async (data: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}/seller/v1/verify/payment`;
  try {
    const response = await axiosInstance.post(url, data);
    return response.data;  // Return only the data part
  } catch (error) {
    console.error('Error Payments:', error);
    throw error;
  }
};

export const AUDIENCEFBSUCESS = () => {
  return `${process.env.REACT_APP_BASE_URL}/seller/v1/oauth_success`;
};

export const FETCHTABDATA = () => {
  return `${process.env.REACT_APP_BASE_URL}/appstore/get/tab`;
};
export const GETCOUPONS = () => {
  return `${process.env.REACT_APP_BASE_URL}/seller/v1/get/coupon`;
};
export const ISVALIDADACCOUNTID = (ad_account_id) => {
  return `${process.env.REACT_APP_BASE_URL}/seller/v1/verify-adaccount?ad_account_id=${ad_account_id}`;
};